import React, { useEffect } from 'react';
import { Avatar, CircularProgress } from '@mui/material';
// import Badge from '@mui/material/Badge';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import UploadButton from '../../Utils/UploadButton';
import useTailwindBrand from '../../Theme/useTailwindBrand';
import { avatarFemale, avatarMale } from '../../Utils/Images';
import { fetchImageProfile } from 'src/Redux/Actions/UserActions';
// import ButtonField from '../Ui/ButtonField';

interface ProfileImageInterface {
    teachr: any,
    getFile?: any,
    text?: string
    icon?: any
    isAvatar: boolean
    profileLoading?: boolean
    width?: number
    height?: number
    variant?: any
    btnDownload?: boolean
    isEditing?: boolean
}

const ProfileImage = ({ teachr, isAvatar, width, height, getFile, profileLoading, variant, btnDownload, isEditing }: ProfileImageInterface) => {
    const { classes } = useTailwindBrand()
    const imageSrc = teachr?.profilePicture?.contentUrl
    const srcImage = imageSrc ? imageSrc : (teachr?.sex === 'MAN' ? avatarMale : avatarFemale)
  
    return (
        <div className={`flex flex-col items-center ${isAvatar && 'bg-gradient-to-r from-[#92D3FF] to-first p-1'} `}>
            {profileLoading ?
                <CircularProgress size={isAvatar ? 30 : height} /> :
                <Avatar
                    variant={variant ?? "circular"}
                    alt={`profile-${teachr?.id}`}
                    src={srcImage}
                    sx={{ width: isAvatar ? 30 : width, height: isAvatar ? 30 : height }}
                    className='border border-gray-300'
                />

            }
            {isEditing &&
                <UploadButton
                    getFile={getFile}
                    button={
                        <div className={`${classes.primaryText} ${classes.primaryBorder} border font-bold text-xs bg-white rounded-md px-3 py-1 flex items-center gap-x-2`}>
                            <AddIcon />
                            {profileLoading ? "Chargement…" : "Changer la photo"}
                        </div>
                    }
                />
            }
            {(!isAvatar && btnDownload && imageSrc) && <UploadButton
                getFile={getFile}
                type={"button"}
                classBtn={"text-normal border-2 border-normal bg-white "}
            />}
        </div>
    );
};

export default ProfileImage;